<template>
  <div style="width: 100vw; height: 100vh;" @click="hideSortMenu">
    <header-sales></header-sales>
    <!--pc view-->
    <div v-if="!mobileView">
      <div id= "subheader"> </div>
      <div id= "main-container">
        <div id= "label-container">
          <span id="label">Nuevo Pedido</span>
        </div>
        <div id= "container">
          <div id="list-header-container">
            <!-- ordenamiento -->
            <div class="fv cc" style="width: 100%; height: 80px;"> 
                <div class="fh cb" style="width: 100%; height: 50px;"> 
                    <input id="busqueda" type="text" placeholder="Búsqueda por código o nombre del producto" v-model="txtBusqueda" v-on:keyup="onKeyDownHandler">
                    <div class="fv cc" id="sortSelected" @click="toggleSortMenu" style="width: 32px; height: 32px; border-radius: 20px; background: #4969B2;
                                        margin-left: 10px; color: white; font-size: 8px" v-show="showSortButton">  
                        <img style="width: 18px; height: 18px;" :src="imageSort"/>                                          
                    </div>
                </div>
                <div class="fh cc" style="width: 100%; height: 30px;" >
                    <div v-show="seleccion != 1">
                        <span class="seleccion" @click="ckCategoria">{{nombreCategoria}}</span>
                        <span class="seleccion" id="separador" v-show='nombreCategoria.length>0'>> </span>
                        <span class="seleccion" @click="ckSubcategoria">{{nombreSubcategoria}}</span>
                    </div>
                </div>
            </div>                                          
            <transition name="fade">
            <div id="sortOptions" v-show="showSortOptions" style="height:200px;  position: absolute; margin-top: 157px; margin-left: 548px; z-index: 99;" >
                <div class="fh cc" @click="sortProductos(1)" >
                    <div class="fv cc" id="sortSelected" style="width: 32px; height: 32px; border-radius: 20px; background: #4969B2;
                                        margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_alf_asc.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 8px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Alfabetico A a Z                      
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(2)" style="margin-top:5px">
                    <div class="fv cc" id="sortSelected" style="width: 32px; height: 32px; border-radius: 20px; background: #4969B2;
                                        margin-left: 10px; color: white; font-size: 8px;">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_alf_des.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 8px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Alfabetico Z a A                      
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(3)" style="margin-top:5px">
                    <div class="fv cc" id="sortSelected" style="width: 32px; height: 32px; border-radius: 20px; background: #4969B2;
                                        margin-left: 10px; color: white; font-size: 8px;">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_cod_asc.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 8px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Código Menor a Mayor                      
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(4)" style="margin-top:5px">
                    <div class="fv cc" id="sortSelected" style="width: 32px; height: 32px; border-radius: 20px; background: #4969B2;
                                        margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_cod_des.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 9px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Código Mayor a Menor                     
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(5)" style="margin-top:5px">
                    <div class="fv cc" id="sortSelected" style="width: 32px; height: 32px; border-radius: 20px; background: #4969B2;
                                        margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_precio_asc.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 9px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Precio Menor a Mayor
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(6)" style="margin-top:5px">
                    <div class="fv cc" id="sortSelected" style="width: 32px; height: 32px; border-radius: 20px; background: #4969B2;
                                        margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_precio_des.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 9px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Precio Mayor a Menor
                    </div>
                </div>
            </div> 
            </transition>  
            <!-- ordenamiento -->

          </div>
          <div id="list-container" v-if="show">
            <item-producto id="list-prod" v-for="item in items" :item='item' v-if="seleccion == 1 || seleccion == 2 || ((seleccion == 3 || seleccion == 4) && item.Precio)" @setItem="setSelection"></item-producto>
          </div>
        </div>
        <div id="btnContainer">
            <button id="btnAgregarPromo" @click="btnAgregarPromo" >AGREGAR COMBOS</button>
            <button id="btnCarrito" @click="btnCarrito" >IR AL CARRITO</button>
        </div>
      </div>
    </div>


    <!--mobile view-->
    <div v-if="mobileView">
        <div class="fh cc" style="width: 100vw; height:4vh;  margin-top:40px; background:#44C7F4; color:white; font: size 12px;">Nuevo Pedido</div>
        <!-- ordenamiento -->
        <div class="fv cc" style="width: 100vw; height: 15vh;">
            <div class="fh cb" style="width: 100%; height: 35px;" @click="toggleSortMenu"> 
                <input id="busqueda" type="text" style="width: 70%; font-size: 11px" placeholder="Búsqueda por código o nombre del producto" v-model="txtBusqueda" v-on:keyup="onKeyDownHandler">   
                <div class="fv cc" id="sortSelected" style="width: 32px; height: 32px; border-radius: 20px; background: #4969B2;
                                    margin-left: 10px; color: white; font-size: 8px" v-show="showSortButton">  
                    <img style="width: 18px; height: 18px;" :src="imageSort" />                                          
                </div>
            </div>
            <div class="fh cc" v-show="seleccion != 1" style="width: 100%; margin-top: 10px">
                <span class="seleccion" @click="ckCategoria">{{nombreCategoria}}</span>
                <span class="seleccion" id="separador" v-show='nombreCategoria.length>0'>> </span>
                <span class="seleccion" @click="ckSubcategoria">{{nombreSubcategoria}}</span>
            </div>
        </div>
        <transition name="fade">
            <div id="sortOptions" v-show="showSortOptions" style="height:200px; position: absolute; margin-top: 5px; margin-left: 192px; z-index: 99; background: white" >
                <div class="fh cc" @click="sortProductos(1)" >
                    <div class="fv cc" style="width: 32px;  height: 32px;   border-radius: 20px; background: #4969B2;
                                            margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_alf_asc.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 8px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Alfabetico A a Z                      
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(2)" style="margin-top:4px">
                    <div class="fv cc" style="width: 32px;  height: 32px;   border-radius: 20px; background: #4969B2;
                                            margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_alf_des.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 8px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Alfabetico Z a A                      
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(3)" style="margin-top:4px">
                    <div class="fv cc" style="width: 32px;  height: 32px;   border-radius: 20px; background: #4969B2;
                                            margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_cod_asc.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 8px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Código Menor a Mayor                      
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(4)" style="margin-top:4px">
                    <div class="fv cc" style="width: 32px;  height: 32px;   border-radius: 20px; background: #4969B2;
                                            margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_cod_des.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 9px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Código Mayor a Menor                     
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(5)" style="margin-top:4px">
                    <div class="fv cc" style="width: 32px;  height: 32px;   border-radius: 20px; background: #4969B2;
                                            margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_precio_asc.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 9px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Precio Menor a Mayor
                    </div>
                </div>
                <div class="fh cc" @click="sortProductos(6)" style="margin-top:4px">
                    <div class="fv cc" style="width: 32px;  height: 32px;   border-radius: 20px; background: #4969B2;
                                            margin-left: 10px; color: white; font-size: 8px">  
                        <img style="width: 18px; height: 18px;" src="/dist/icon_precio_des.png" />                                          
                    </div>
                    <div class="fh cc" style="font-size: 9px; color: white; background: #5C666F; 
                                              width: 100px; height: 22px; border-radius: 5px; margin-left: 5px">
                        Precio Mayor a Menor
                    </div>
                </div>
            </div> 
            </transition>  
        <!-- ordenamiento -->
        <div id="list-container" v-if="show" style="width: 86vw; height: 60vh; margin-left: 8vw">
            <item-producto id="list-prod" v-for="item in items" :item='item' v-if="seleccion == 1 || seleccion == 2 || ((seleccion == 3 || seleccion == 4) && item.Precio)" @setItem="setSelection"></item-producto>
        </div>
        <div class="fh cc" style="width: 100%; height: 21vh;">
            <button id="btnAgregarPromo" @click="btnAgregarPromo" >AGREGAR COMBOS</button>
            <button id="btnCarrito" @click="btnCarrito" >IR AL CARRITO</button>
        </div>
    </div>   

 <!-- ..................................popup..............................   -->

 <!--pc view-->
 <transition name="fadePro">
   <div v-show='seleccion==4 && !mobileView' :seleccion='seleccion'>
       <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100vh; background: #000000;
                 opacity: 0.6; filter: alpha(opacity=60);">  
       </div>
       <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); width: 400px;
                 border-radius: 15px; box-sizing: border-box; border: 1px solid #dddddd; background: white">
            <div class="fh rc" style='margin-top: 10px; height: 20px; padding-right: 10px;'>
                <img id='btnClose' v-on:click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
            </div>
            <div class="fh cc" style='margin-top: 5px; font-size: 18px; color: #5C666F; font-weight: bold;'>{{nombreProducto}}</div>

            <div class="fh ct"  style='width: 100%; margin-top: 10px;; height: 250px'>
                <div class="fv ct"  style='width: 45%; height: 100%'>
                    <div class="fh ct" style='width: 100%; margin-top:20px' >
                        <!-- <img style="width: 95%; height: 95%; object-fit: contain" :src="imagenProducto" > -->
                        <img style="width: 167px; height: 167px; object-fit: contain" :src="imagenProducto" >
                    </div>
                    <div class="fh rt" style='width: 100%; margin-top:15px; margin-right:15px;font-size: 12px; color: #5C666F;' >
                        Subtotal:
                    </div>
                    <div class="fh rt" style='width: 100%; margin-right:15px; font-size: 12px; color: #5C666F;' >
                        Descuentos:
                    </div>
                    <div class="fh rt" style='margin-top:7px; width: 100%; font-weight:500; margin-right:15px; font-size: 17px; color: #5C666F;' >
                        Total:
                    </div>
                </div>

                <div class="fv lc" style='width: 55%'>
                    <!-- <div class="fv lc" style='width: 100%'> -->
                        <div class="fh cc" style='width: 100%; height: 30px;'></div>

                        <div v-show="esPromo" class="fh cc" style="margin-bottom: 5px;" >
                            <img style="width: 38px;" src="/dist/icon_promo.png"/>
                            <div style='font-size: 13px; color: #000000; margin-left: 8px'>{{prodEnPromo}}</div>
                        </div>

                        <div v-show='precioProductoOferta > 0' class="fh lc" style='margin-top: 0px; font-size: 16px; color: #999999; font-weight: 500; text-decoration-line:line-through'>
                            ${{compPrecioProducto | formatMoney}}
                        </div>

                        <div class="fh lc" style='margin-top: 0px; font-size: 16px; color: #4969B2; font-weight: 500;'>
                            ${{compPrecio | formatMoney}}
                        </div>
 
                        <div class="fh cc" style='width: 100%; margin-top: 10px'>

                            <div class="fh lc" style="width: 60%; font-size: 12px; color: #5C666F">
                                CANTIDAD
                            </div>
                            <div class="fv lc" style="width: 40%">                           
                                <div class="fh lc" style="width: 100%">
                                    <input :class='{popupCantidad:cantValida,popupCantidadInv:!cantValida}' type="text"  v-model='cantidadProducto' v-on:keyup="updateCantidad">
                                    <div style="margin-left:5px; font-size: 11px; color: #5C666F">unid</div>
                                </div>
                            </div>

                        </div>

                        <div class="fv lt" style='width: 100%'>
                            <div class="fh lc" style="width: 60%"></div>
                            <div :class='{popupMaximoPorcentaje:cantValida,popupMaximoPorcentajeInv:!cantValida}' 
                                 style="margin-top: 4px; margin-right:10px" v-show=showMinUnidades>
                                {{minUnidades}}
                            </div>
                            <div :class='{popupMaximoPorcentaje:esMultiploValido,popupMaximoPorcentajeInv:!esMultiploValido}' 
                                  style="margin-top: 4px; margin-right:10px" v-show=showPacks>
                                (Packs de {{UnidadesPorPedido}} unidades)
                            </div>
                            <div class='popupMaximoPorcentajeInv' style="margin-top: 4px; margin-right:10px" 
                                 v-show=!esMultiploValido>
                                 {{valorCercano}}
                            </div>
                        </div>

                        <div class="fh cc" style='width: 100%; margin-top: 10px;' v-show='mostrarDescuento'>
                            <div class="fh lc" style="width: 60%; font-size: 12px; color: #5C666F">
                                DESCUENTO
                            </div>
                            <div class="fv lc" style="width: 40%">                           
                                <div class="fh lc" style="width: 100%">
                                    <input :class='{popupCantidad:porcValido,popupCantidadInv:!porcValido}' type="text" value="0" v-model='porcentajeDescuento' v-on:keyup="updatePorcentaje">
                                    <div class='popupMaximoPorcentaje' style="margin-top: 7px; margin-left: 5px">%</div>
                                </div>
                            </div>
                        </div>
                        <div class="fv lt" style='width: 100%; margin-top: 5px' v-show='mostrarDescuento'>
                            <div :class='{popupMaximoPorcentaje:porcValido,popupMaximoPorcentajeInv:!porcValido}'>
                                {{maximoDescuento}}
                            </div>
                        </div>


                        <!-- Nuevos descuentos por cantidad -->
                        <div class="fh lc" v-show='showDescAsoc' style="margin-top: 10px; width: 60%; font-size: 10px; color: #5C666F">Descuentos Asociados</div>
                        <ul style='margin-top: 5px; margin-left: 0px; height: 50px; overflow: auto'>
                           <li style='font-size: 9px; color: #656E76; height: 12px; margin-top: 0px; margin-bottom: 2px' v-for="descAsoc in descAsocs">&#8226; {{ descAsoc.Titulo }}</li>
                        </ul>

                        <!-- <div class="fh cc" v-show='showDescAsoc' style='width: 100%; margin-top: 5px;'>
                            <div class="fh lc" style="width: 40%; font-size: 10px; color: #5C666F; font-weight:500">Descuentos:</div>
                            <div class="fh rc" style="margin-right: 28px; width: 60%; font-size: 12px; color: #5C666F; font-weight:500">${{totalDescAsoc | formatMoney}}</div>
                        </div>

                        <div class="fh cc" style='width: 100%; margin-top: 15px;'>
                            <div class="fh lc" style="width: 40%; font-size: 12px; color: #5C666F; font-weight:500">SUBTOTAL</div>
                            <div class="fh cc" style="width: 60%; font-size: 16px; color: #5C666F; font-weight:500">${{subtotal | formatMoney}}</div>
                        </div> -->
       
                        <div class="fh rc" style="width: 90%; font-size: 12px; color: #5C666F; font-family: monospace">
                            ${{subtotal | formatMoney}}
                        </div>
                        <div class="fh rc" style="width: 90%; font-size: 12px; color: #5C666F; font-family: monospace">
                            -${{totalDescAsoc | formatMoney}}
                        </div>
                        <div class="fh rc" style="margin-top:7px; width: 90%; font-size: 17px; color: #5C666F; font-weight:500">
                            ${{subtotal - totalDescAsoc | formatMoney}}
                        </div>
       

                    <!-- </div> -->
                     
                </div>
               
            </div>

            <div id="btnContainerPopup" style="margin-top: 10px">
                <button  @click="btnCerrarPopup" id="btnCerrarPopup">CANCELAR</button>
                <button  @click="btnAgregar"     id="btnAgregarPopup">AGREGAR AL CARRITO</button>
            </div>
        </div>
   </div>
  </transition>



 <!--mobile view-->
 <transition name="fadePro">
   <div v-show='seleccion==4  && mobileView' :seleccion='seleccion'>
     <div style="position: absolute; top: 0; left: 0; width: 100vw; height: 100vh; background: #000000; opacity: 0.8; filter: alpha(opacity=80);"> </div>
     <div style="position: absolute; width: 96vw; height: 84vh; min-height: 480px;  background: white; top: 8%;left: 2%; z-index: 10">
          <div class="fh rb" style="width: 100%; height: 8%;">
            <img id='btnClose' v-on:click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 30px; height: 30px; margin-right: 10px">
          </div>
          <div v-show="esPromo" class="fh cc">
               <img  style="width: 38px;" src="/dist/icon_promo.png"   />
          </div>
          <div class="fh cc" style="width: 100%; height: 8%; font-size: 15px; font-weight: 600;">{{nombreProducto}}</div>
          <div class="fh cc" style="width: 100%; height: 25%;">
            <div class="fh cc" style="width: 50%; height: 100%;">
              <img style="width: 90%; height: 90%; object-fit: contain" :src="imagenProducto" >
            </div>
            <div class="fv cc" style="width: 50%; height: 100%;"> 
              <div v-show='precioProductoOferta > 0' style="margin-left: 0px; margin-top: 12px; font-size: 16px; color: #999999; font-weight: 800; text-decoration-line:line-through">${{compPrecioProducto | formatMoney}}</div>
              <div style="margin-left: 0px; margin-top: 0px; font-size: 16px; color: #4969B2; font-weight: 800">${{compPrecio | formatMoney}}</div>
            </div>
          </div>
          <div class="fh cc" style="width: 100%; height: 6%;margin-top: 10px"> 
            <div class="fv lc" style="margin-left: 40px;  width: 40%; height: 100%; font-size: 14px"> 
              CANTIDAD
            </div>
            <div class="fh rc" style="width: 60%; height: 100%;"> 
              <input :class='{popupCantidad:cantValida&&esMultiploValido,popupCantidadInv:!cantValida||!esMultiploValido}' type="text"  v-model='cantidadProducto' v-on:keyup="updateCantidad">
              <div style="width:50px; margin-left: 10px; margin-right: 10px">unid</div>
            </div>
          </div>
          <div class="fh ct" style="width: 100%; height: 5%;"> 
            <div class="fv cc" style="width: 40%; height: 100%;"> 
            </div>
            <div class="fv rt" style="width: 60%; height: 100%;margin-right: 30px"> 
                <span :class='{popupMaximoPorcentaje:cantValida,popupMaximoPorcentajeInv:!cantValida}' v-show=showMinUnidades>{{minUnidades}}</span>
                <span :class='{popupMaximoPorcentaje:esMultiploValido,popupMaximoPorcentajeInv:!esMultiploValido}' v-show=showPacks>(Packs de {{UnidadesPorPedido}} unidades)</span>
                <span class='popupMaximoPorcentajeInv' v-show=!esMultiploValido >{{valorCercano}}</span>
            </div>
          </div>
          <div class="fh cc" style="width: 100%; height: 8%;" v-show='mostrarDescuento'> 
            <div class="fv lc" style="margin-left: 40px; width: 40%; height: 100%; font-size: 14px"> 
              DESCUENTO
            </div>
            <div class="fh rc" style="width: 60%; height: 100%;"> 
              <input :class='{popupCantidad:porcValido,popupCantidadInv:!porcValido}' type="text" value="0" v-model='porcentajeDescuento' v-on:keyup="updatePorcentaje">
              <div style="width:50px; margin-left: 10px; margin-right: 10px">%</div>
            </div>
          </div>
          <div class="fh ct" style="width: 100%; height: 3%;"> 
            <div class="fv cc" style="width: 40%; height: 100%;"> 
            </div>
            <div class="fv rt" style="width: 60%; height: 100%;margin-right: 30px"> 
              <span :class='{popupMaximoPorcentaje:porcValido,popupMaximoPorcentajeInv:!porcValido}' v-show='mostrarDescuento'>{{maximoDescuento}}</span>
            </div>
          </div>
          <div class="fh cc" style="width: 100%; height: 15%;"> 
            <div class="fv lc" style="margin-left: 40px; width: 40%; height: 100%; font-size: 14px">SUBTOTAL</div>
            <div class="fv cc" style="width: 60%; height: 100%; font-size: 20px; font-weight: 800;">${{subtotal | formatMoney}}</div>
          </div>
          <div class="fh cb" style="width: 100%; height: 15%;"> 
            <button  @click="btnCerrarPopup" id="btnCerrarPopup">CANCELAR</button>
            <button  @click="btnAgregar"     id="btnAgregarPopup">AGREGAR AL CARRITO</button>
          </div>
     </div>

   </div>
 </transition>

 </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemProducto from '@components/views/realizarPedido/itemRealizarPedido.vue';
  


  export default {
     name: 'RealizarPedido',
     components:{
      'header-sales': HeaderSales,
      'item-producto': ItemProducto,
     },
     data() {
       return {
        show:true, 
        txtBusqueda:'',
        verBusqueda:false,
        seleccion:0,
        idCategoria:-1,
        idSubcategoria:-1,
        idProducto:-1,
        nombreCategoria:"",
        nombreSubcategoria:"",
        nombreProducto:"",
        descripcionProducto:"",
        UnidadesPorPedido:1,
        UnidadesMinimaVenta:0,
        stockActual:0,
        porcentajeDescuento:0,
        porcentajeImpuesto:0,
        detalle:"",
        precioProducto:0.0,
        precioProductoOferta:0.0,
        esPromo:false,
        cantidadProducto:0,
        permiteDecimales:false,
        peso:0.0,
        ImagenUrl: '',
        porcValido:true,
        cantValida:true,
        categoriaN1:'',
        categoriaN2:'',
        items: [],
        imagenProducto : '/dist/placeholder-producto.png',
        idProdSelect: -1,
        mobileView:false,
        showSortButton:false,
        showSortOptions:false,
        imageSort : '/dist/icon_alf_asc.png',
        prodEnPromo: '',
        descAsocs: []
       }
    },


    watch: {
    $route (to, from) {
      if ((from.name=="realizarPedidoSubcat") && (to.name=="realizarPedidoCat")) {
         this.seleccion = 0;
         this.showItems();
       }
      if ((from.name=="realizarPedidoProd") && (to.name=="realizarPedidoSubcat")) {
         this.seleccion = 1;
         this.showItems();
       }
     }
    },


    computed: {
    
      compPrecio() {
        if (this.precioProductoOferta > 0) {
            return this.precioProductoOferta * (1 + (this.porcentajeImpuesto/100));
        }
        else {
            return this.precioProducto * (1 + (this.porcentajeImpuesto/100));
        }
      },

      compPrecioProducto() {
          return this.precioProducto * (1 + (this.porcentajeImpuesto/100));
      },

      productos() {
        return this.$store.state.pedido.productos;
      },

      subtotal() {
        var precio = 0.0
        if (this.precioProductoOferta > 0) {
           precio = this.precioProductoOferta
        }
        else {
           precio = this.precioProducto
        }
        var precioImp = precio * (1 + (this.porcentajeImpuesto/100))
        var sub = this.cantidadProducto * precioImp   
        var porc = this.porcentajeDescuento / 100
        return sub - (porc*sub)
      },

      maximoDescuento() {
        return "("+this.$store.state.user.usuario.PorcentajeDescuentoMaximoPrecio +"% máximo descuento permitido)";
      },
      mostrarDescuento() {
        if ((this.$store.state.user.usuario.EsEmpleado) && (this.$store.state.user.cliente.PermiteDescuentoPrecio)) {
          return true   
        }
        else {
          return false  
        }
      },
      mostrarDetalle() {
        if (this.tipoProducto == 2) {
          return true
        }
        else {
          return false
        }
      },
      showPacks() { 
        if (this.UnidadesPorPedido > 1) {
          return true;
        } 
        else {
          return false;
        }
      },
      showMinUnidades() {
        if (this.UnidadesMinimaVenta > 1) {
          return true;
        }
        else {
          return false;
        }
      },
      minUnidades() {
        return '(Cantidad minima '+this.UnidadesMinimaVenta+' uds.)'
      },
      esMultiploValido() {
        if (this.permiteDecimales) {
          return true  
        }
        else {
          if (this.cantidadProducto % this.UnidadesPorPedido == 0) {
            return true  
          } 
          else {
            return false  
          }
        }
      },
      valorCercano() {
        var ent = Math.trunc(this.cantidadProducto/this.UnidadesPorPedido)  
        var inf = ent*this.UnidadesPorPedido  
        var sup = (ent+1)*this.UnidadesPorPedido  
        if (inf<=0) {
          return '(Valor cercano '+sup+')'  
        }
        else {
          return '(Valores cercanos '+inf+' - '+sup+')'  
        }
      },

      showDescAsoc() {
        if(this.descAsocs.length > 0) {
          return true  
        }
        else {
          return false  
        }
      },


      totalDescAsoc() {
        var carrito = this.$store.state.pedido.carrito
        var subtotal = 0
        var cantProd = Number(this.cantidadProducto)
        var descTotal = 0
        var desc = 0
        var nivel = 0
        var excluyente = false
        var precio = 0.0

        if (this.precioProductoOferta > 0) {
           precio = this.precioProductoOferta
        }
        else {
           precio = this.precioProducto
        }

        this.descAsocs.sort((a, b) => {
            if (a.Nivel === b.Nivel) {
                //return b.Secuencia - a.Secuencia;
                return b.Secuencia - a.Secuencia;
            }
            return a.Nivel - b.Nivel;
        });

        this.descAsocs.forEach((i,a) => { 

            // afecta a categoriasN1 
            if (i.AfectaA == 2) {
                var encontrado = false
                carrito.every((prod) => { 
                    encontrado = i.CategoriaN1.some(d => d.Id === prod.idCategoria)
                    if (encontrado) {
                        cantProd =  Number(cantProd) + Number(prod.cantidad)
                        return false
                    }
                    return true
                });  
            } 

            // afecta a categoriasN2 
            if (i.AfectaA == 3) {
                var encontrado = false
                carrito.every((prod) => { 
                    encontrado = i.CategoriaN2.some(d => d.Id === prod.idSubcategoria)
                    if (encontrado) {
                        cantProd = cantProd + prod.cantidad
                        return false
                    }
                    return true
                });  
            } 

            i.Escalas.forEach((j) => { 
                if (a == 0) {
                    nivel = i.Nivel 
                    subtotal = Number(precio * this.cantidadProducto)
                    excluyente = false
                }   
                else if (i.Nivel != nivel) {
                    nivel = i.Nivel 
                    subtotal = subtotal - desc 
                    desc = 0
                    excluyente = false
                } 
                if (!excluyente) {
                    // importe            
                    if (i.Tipo == 1) { 
                        if (Number(j.ValorDesde) <= Number(subtotal)) {
                            if ((Number(j.ValorHasta) == 0) || (Number(subtotal) <= Number(j.ValorHasta))) {
                                desc = desc + (subtotal * (j.PorcentajeDescuento/100))
                                descTotal = descTotal + (subtotal * (j.PorcentajeDescuento/100))
                            }
                        } 
                    }
                    // unidades
                    if (i.Tipo == 2) { 
                        if (Number(j.ValorDesde) <= Number(cantProd)) {
                            if ((Number(j.ValorHasta) == 0) || (Number(cantProd) <= Number(j.ValorHasta))) {
                                desc = desc + (subtotal * (j.PorcentajeDescuento/100))
                                descTotal = descTotal + (subtotal * (j.PorcentajeDescuento/100))
                            }
                        } 
                    }
                }
                if (i.Excluyente) {
                    excluyente = true
                }
            });  
        });  
        return descTotal
      }
    },

    methods: {

      onResize() {
        if (window.innerWidth > 600) {
          this.mobileView=false;
        }
        else {
          this.mobileView=true;
        }
      },


      onKeyDownHandler() {
        if (this.txtBusqueda.length > 1) {
          this.verBusqueda = true;
          this.seleccion = 3
          this.items = this.productos.filter((item) =>  {
            if ((item.Nombre != null) && (item.Codigo != null)) {
              return (item.Nombre.toLowerCase().includes(this.txtBusqueda.toLowerCase()))
                  || (item.Codigo.toLowerCase().includes(this.txtBusqueda.toLowerCase()))
            }
            else if (item.Nombre != null) {
              return (item.Nombre.toLowerCase().includes(this.txtBusqueda.toLowerCase()))
            }
            else if (item.Codigo != null) {
              return (item.Codigo.toLowerCase().includes(this.txtBusqueda.toLowerCase()))
            }
          });
        }
        if(this.txtBusqueda.length == 0) {
          this.verBusqueda = false;
          this.seleccion=0;
          this.showItems();
        }
        this.$store.commit('pedido/setSeleccion',this.seleccion);
      },

      categorizacion1(){
         this.$store.commit('loader/start')
         axios.get('/WebSalesCategorias?Categorizacion1Id=0',{
            headers:{
                      Token:        this.$store.state.user.usuario.Token,
                      ClientSecret: this.$store.state.entorno.clientSecret,
                      EmpresaId:    this.$store.state.entorno.idEmpresa
                    }
          }
          ).then((response) => {
            //   console.log(response)
              this.$store.commit('loader/stop')
              if (response.data.Code == 0)
              {
                 this.items = []
                 this.items = response.data.Categorias
                 this.items.map((e) => {
                   e.showCheck = false;
                  return e;
                 })
              }
              else if (response.data.Code == 99)
              {
                 alert(response.data.Message)
                 this.$router.push({name: 'login'});
              }
              else
              {
                alert(response.data.Message);
                // console.log(">>code>>"+response.data.Code);
              }
          },(error) => {
            // console.log(error)
            this.$store.commit('loader/stop')
            alert(error);
            })
     }, 


     categorizacion2(){
         this.$store.commit('loader/start')
         axios.get('/WebSalesCategorias?Categorizacion1Id='+this.idCategoria,{
            headers:{
                      Token:        this.$store.state.user.usuario.Token,
                      ClientSecret: this.$store.state.entorno.clientSecret,
                      EmpresaId:    this.$store.state.entorno.idEmpresa
                    }
          }
          ).then((response) => {
            //   console.log(response)
              this.$store.commit('loader/stop')
              if (response.data.Code == 0)
              {
                 this.items = []
                 this.items = response.data.Categorias
                 if (this.items.length == 0){
                   this.seleccion=2
                   this.idSubcategoria=0
                   this.showItems()
                 }
                 this.items.map((e) => {
                   e.showCheck = false;
                  return e;
                 })
              }
              else if (response.data.Code == 99)
              {
                 alert(response.data.Message)
                 this.$router.push({name: 'login'});
              }
              else
              {
                alert(response.data.Message);
                // console.log(">>code>>"+response.data.Code);
              }
          },(error) => {
            // console.log(error)
            this.$store.commit('loader/stop')
            alert(error);
            })
     }, 

     showItems() {
        if (this.seleccion == 0)
        {
           this.showSortButton=false
           this.seleccion=1;
           this.$store.commit('pedido/setSeleccion',this.seleccion);
           this.categorizacion1()
        }
        else if (this.seleccion == 1)
        {
           this.showSortButton=false
           this.seleccion=2;
           this.$store.commit('pedido/setSeleccion',this.seleccion);
           this.categorizacion2()
        }
        else if (this.seleccion == 2)
        {
           this.showSortButton=true 
           this.seleccion=3;
           this.$store.commit('pedido/setSeleccion',this.seleccion);
           this.items = [];
           this.items = this.productos.filter((item) =>  {return item.Categorizacion1Id == this.idCategoria  && item.Categorizacion2Id == this.idSubcategoria});
           this.sortProductos(Number(localStorage.getItem("ordenamiento") || 1))
           var carrito = this.$store.state.pedido.carrito
           this.items.map((e) => {
             var enCarrito = false;
             carrito.forEach((j)=> {
               if (e.Id === j.id)
               {
                  enCarrito = true
               }
             });
             e.showCheck = enCarrito;
             return e;
           })
        }
      },


      setSelection(id) {
        if (this.seleccion == 1)
        {
          this.$router.push({name: 'realizarPedidoSubcat'});
          this.idCategoria = id;
          var cat = this.items.find( item => item.Id === this.idCategoria);
          this.nombreCategoria = cat.Nombre;
          this.nombreSubcategoria = '';
          this.showItems();
        }
        else if (this.seleccion == 2)
        {
          this.$router.push({name: 'realizarPedidoProd'});
          this.idSubcategoria = id;
          var itemSubcategoria = this.items.find( item => item.Id === this.idSubcategoria);
          this.nombreSubcategoria = itemSubcategoria.Nombre;
          this.showItems();
        }
        else if (this.seleccion == 3)
        {
          var carrito = this.$store.state.pedido.carrito
          var enCarrito = false;
          carrito.forEach((j)=> {
            if (id === j.id)
              {
                enCarrito = true
              }
          });
          this.idProdSelect = id
          if (!enCarrito)
          {
            this.showProductoEnPopup()
          }
          else
          {
            var obj = {
                       txt:'El producto seleccionado ya se encuentra en el carrito de compras, si desea agregar más unidades puede hacerlo desde allí',
                       txtBtnCancel:'Agregar',
                       txtBtnOk:'Ir al carrito',
                       fCancel:this.showProductoEnPopup,
                       fOk:this.irAlCarrito
                      }
            this.$store.commit('popup/open',obj);
          }
        }
      },



      showProductoEnPopup() {
            this.idProducto = this.idProdSelect;
            var itemProducto = this.items.find( item => item.Id === this.idProducto);

            if ((this.$store.state.user.usuario.ControlaStock) && (itemProducto.StockActual < 1))
            {
              var obj = {
                        txt:'No hay stock disponible del producto seleccionado',
                        txtBtnCancel:"",
                        txtBtnOk:'Aceptar',
                        fCancel:null,
                        fOk:null
                        }
              this.$store.commit('popup/open',obj);
            }  
            else
            {
              this.categoriaN1 = itemProducto.Categorizacion1Id,  
              this.categoriaN2 = itemProducto.Categorizacion2Id,  
              this.UnidadesPorPedido = itemProducto.UnidadesPorPedido;
              this.UnidadesMinimaVenta = itemProducto.UnidadesMinimaVenta;
              this.stockActual = itemProducto.StockActual;
              this.nombreProducto = itemProducto.Nombre;
              this.descripcionProducto = itemProducto.Nombre;
              this.precioProducto = itemProducto.Precio;
              this.precioProductoOferta = itemProducto.PrecioOferta;
              this.esPromo = itemProducto.EsPromo;

              this.prodEnPromo = '';
              if (this.esPromo) {
                this.$store.state.pedido.promociones.forEach((promo)=> {
                  var combo = promo.Productos.find((p) =>  {return p.ProductoId == itemProducto.Id});
                  if (combo != null) {
                    this.prodEnPromo = promo.Nombre
                  }
                });
              }

              this.permiteDecimales = itemProducto.CantidadPermiteDecimales;
              if  (this.UnidadesMinimaVenta > 0) 
              {
                this.cantidadProducto = this.UnidadesMinimaVenta
              } 
              else
              {
                this.cantidadProducto = this.UnidadesPorPedido
              }
              this.peso = itemProducto.Peso;
              this.ImagenUrl = itemProducto.ImagenUrl;

              this.imagenProducto=null;
              if ((this.ImagenUrl != null) && (this.ImagenUrl != '')){
                this.imagenProducto = this.ImagenUrl
              }
              else {
                this.imagenProducto = '/dist/placeholder-producto.png'
              }

              this.seleccion=4;
              this.porcentajeDescuento = 0;
              this.porcentajeImpuesto = itemProducto.PorcentajeImpuesto;
            }
            this.setDescAsoc()
      },


      toggleSortMenu() {
        setTimeout(() => {
          if (this.showSortOptions) {
            this.showSortOptions = false
          }  
          else {
            this.showSortOptions = true
          }
        }, 50);
      },
      hideSortMenu() {
          this.showSortOptions = false
      },
      sortProductos(i) {
        this.showSortOptions = false
        localStorage.setItem("ordenamiento",i)
        switch (i) {
          case 1: 
            this.imageSort = '/dist/icon_alf_asc.png' 
            this.items.sort((a, b) => {
                if (a.Nombre > b.Nombre) {
                    return 1;
                }
                if (a.Nombre < b.Nombre) {
                    return -1;
                }
                return 0;
            });
            break;
          case 2: 
            this.imageSort = '/dist/icon_alf_des.png' 
            this.items.sort((a, b) => {
                if (b.Nombre > a.Nombre) {
                    return 1;
                }
                if (b.Nombre < a.Nombre) {
                    return -1;
                }
                return 0;
            });
            break;
          case 3: 
            this.imageSort = '/dist/icon_cod_asc.png' 
            this.items.sort((a,b)=> {return a.Codigo - b.Codigo});  
            break;
          case 4: 
            this.imageSort = '/dist/icon_cod_des.png' 
            this.items.sort((a,b)=> {return b.Codigo - a.Codigo}); 
            break;
          case 5: 
            this.imageSort = '/dist/icon_precio_asc.png' 
            this.items.sort((a,b)=> {return a.Precio - b.Precio}); 
            break;
          case 6: 
            this.imageSort = '/dist/icon_precio_des.png' 
            this.items.sort((a,b)=> {return b.Precio - a.Precio}); 
            break;
        }  
      },

      irAlCarrito(){
        this.$router.push({name: 'pedido'});
      },

      ckCategoria() {
        this.seleccion = 0;
        this.showItems();
      },

      ckSubcategoria() {
        this.seleccion = 1;
        this.showItems();
      },

      btnCerrarPopup() {
        this.seleccion = 3;
        this.idProducto = -1;
        this.nombreProducto = "";
        this.descripcionProducto = "";
        this.precioProducto = 0.0;
      }, 

      btnAgregar() {
        var precioF = 0.0 
        if (this.precioProductoOferta < 1) {
            precioF = this.precioProducto
          }
        else {
            precioF = this.precioProductoOferta
        }  

        // console.log('<this.idCategoria>')
        // console.log(this.idCategoria)

        if (this.validar())
        {
          this.seleccion = 3;
          var nuevoProducto = {
            id: this.idProducto,
            // idCategoria: this.idCategoria,
            // idSubcategoria: this.idSubcategoria,
            idCategoria: Number(this.categoriaN1),
            idSubcategoria: Number(this.categoriaN2),
            producto: this.nombreProducto,
            descripcion: this.descripcionProducto,
            precioLista: this.precioProducto,
            precio: precioF,
            esPromo: this.esPromo,
            descuento: this.precioProducto*(this.porcentajeDescuento/100),
            porcentajeDescuento:this.porcentajeDescuento,
            porcentajeImpuesto:this.porcentajeImpuesto,
            cantidad: this.cantidadProducto,
            peso:this.peso,
            ImagenUrl: this.ImagenUrl,
            promocionId:0,
            unidadesPorPedido:this.UnidadesPorPedido,
            unidadesMinimaVenta:this.UnidadesMinimaVenta,
            permiteDecimales:this.permiteDecimales,
            tipoOblea:1
          };

          var carrito = this.$store.state.pedido.carrito
          if (carrito != null)
          {
            var it = carrito.find( e => e.id === nuevoProducto.id)

            if ((it != null) && (it.porcentajeDescuento == nuevoProducto.porcentajeDescuento))
            {
               it.cantidad = parseInt(it.cantidad) + parseInt(nuevoProducto.cantidad)  
               this.$store.commit('pedido/updateItemCarrito', it)
            }
            else
            {
              this.$store.commit('pedido/agregarAPedido',nuevoProducto)  
            }
          }
          else
          {
            this.$store.commit('pedido/agregarAPedido',nuevoProducto)
          }
        }
        this.items.forEach((j) => {  
          if (j.Id == this.idProducto) {
            j.showCheck = true;  
          } 
        });  
        this.show = false;
        setTimeout(() => this.show = true, 50);
      },

      updateCantidad() {
        if (this.permiteDecimales) {
            var rex = new RegExp(/^[0-9]+([.,][0-9]+)?$/);
            if (rex.test(this.cantidadProducto)) {
                this.cantValida = true
            }
            else {
                this.cantValida = false
            }
            if (this.cantidadProducto.includes(',')){
                this.cantidadProducto = this.cantidadProducto.replace(',','.')
            } 
        } 
        else {
            var rex = new RegExp(/^\d+$/);
            if (rex.test(this.cantidadProducto))
            {
                var minVenta = 1
                if (this.UnidadesMinimaVenta > 1)
                {
                    minVenta = this.UnidadesMinimaVenta
                }
                if (this.cantidadProducto >= minVenta)
                {
                    this.cantValida = true
                }
                else
                {
                    this.cantValida = false
                }
            }
            else
            {
                this.cantValida = false
            }
        }
      },


      updatePorcentaje() {
        var rex = new RegExp(/^\d+$/);
        if (rex.test(this.porcentajeDescuento))
        {
          if (this.porcentajeDescuento > this.$store.state.user.usuario.PorcentajeDescuentoMaximoPrecio)
          {
            this.porcValido = false
          }
          else
          {
            this.porcValido = true
          }
        }
        else
        {
          this.porcValido = false
        }
      },
 

      validar() {
        var msg = '' 
        var valido = true
        var rex = new RegExp(/^\d+$/)
        var rex2 = new RegExp(/^[0-9]+([.][0-9]+)?$/);
        var pesoTotalPedido = 0
        var pesoTotalActual = 0
        var importeTotalPedido = 0
        var importeTotalActual = 0
        var itemsPedido =  this.$store.state.pedido.carrito
        var limiteCtaCte = this.$store.state.user.cliente.LimiteCtaCte

        if (this.permiteDecimales) {
            if ((rex2.test(this.cantidadProducto)) && (rex.test(this.porcentajeDescuento))) {
                if (this.cantidadProducto <= 0 )
                {
                    msg='La cantidad debe ser mayor a 0'
                    valido=false;
                }
                if (this.$store.state.user.usuario.ControlaStock)
                {
                    if (Number(this.stockActual) < Number(this.cantidadProducto))
                    {
                        msg='El stock actual del producto es de '+this.stockActual
                        valido=false;
                    }               
                }
                if (this.$store.state.user.usuario.ControlaCredito)
                {
                    if (Number(importeTotalActual) > Number(limiteCtaCte))
                    {
                        msg='El importe actual del pedido (' +importeTotalActual  +') sobrepasa el saldo restante del límite de la Cuenta Corriente (' +limiteCtaCte +')'
                        valido=false;
                    }               
                }
                if (this.porcentajeDescuento > this.$store.state.user.usuario.PorcentajeDescuentoMaximoPrecio)
                {
                    msg='El porcentaje de descuento ingresado no puede ser mayor que el máximo porcentaje permitido'
                    valido=false;
                }
                if ((!rex2.test(this.cantidadProducto)) || (!rex.test(this.porcentajeDescuento)))
                {
                    if (this.$store.state.user.cliente.PermiteDescuentoPrecio)
                    {
                        msg='Los campos cantidad y porcentaje deben contener un valor numérico'
                    }
                    else
                    {
                        msg='El campo cantidad debe contener un valor numérico'
                    }
                    valido=false;
                }
                if (!valido) 
                {
                    var obj = {
                                txt: msg,
                                txtBtnCancel:'',
                                txtBtnOk:'Aceptar',
                                fCancel:null,
                                fOk:null
                                }
                    this.$store.commit('popup/open',obj);
                }
            }
        }
        else {
            if ((rex.test(this.cantidadProducto)) && (rex.test(this.porcentajeDescuento)))
            {
                if ((this.cantidadProducto < 1) || (this.cantidadProducto < this.UnidadesMinimaVenta))
                {
                    msg='La cantidad minima debe ser de ' + this.UnidadesMinimaVenta + ' unidades de venta'
                    valido=false;
                }
                if (this.$store.state.user.usuario.ControlaStock)
                {
                    if (Number(this.stockActual) < Number(this.cantidadProducto))
                    {
                        msg='El stock actual del producto es de '+this.stockActual+' unidades'
                        valido=false;
                    }               
                }
                if (this.$store.state.user.usuario.ControlaCredito)
                {
                    if (Number(importeTotalActual) > Number(limiteCtaCte))
                    {
                        msg='El importe actual del pedido (' +importeTotalActual  +') sobrepasa el saldo restante del límite de la Cuenta Corriente (' +limiteCtaCte +')'
                        valido=false;
                    }               
                }
                if (this.porcentajeDescuento > this.$store.state.user.usuario.PorcentajeDescuentoMaximoPrecio)
                {
                    msg='El porcentaje de descuento ingresado no puede ser mayor que el máximo porcentaje permitido'
                    valido=false;
                }
                if (this.UnidadesPorPedido > 1)
                {
                    if (this.cantidadProducto % this.UnidadesPorPedido != 0)
                    {
                        msg='El producto tiene que contener una cantidad múltiplo de su unidad de venta'
                        valido=false;
                    }
                }
            }
            if ((!rex.test(this.cantidadProducto)) || (!rex.test(this.porcentajeDescuento)))
            {
                if (this.$store.state.user.cliente.PermiteDescuentoPrecio)
                {
                    msg='Los campos cantidad y porcentaje deben contener un valor numérico'
                }
                else
                {
                    msg='El campo cantidad debe contener un valor numérico'
                }
                valido=false;
            }
            if (!valido) 
            {
                var obj = {
                            txt: msg,
                            txtBtnCancel:'',
                            txtBtnOk:'Aceptar',
                            fCancel:null,
                            fOk:null
                            }
                this.$store.commit('popup/open',obj);
            }
        }
        return valido
      },


      btnAgregarPromo () {
      this.$router.push({name: 'promociones'});
      },

      btnCarrito () {
        if (this.$store.state.pedido.tipoOperacion == 'pedido') {
          this.$router.push({ name: 'pedido' });
        }
        else if (this.$store.state.pedido.tipoOperacion == 'presupuesto') {
          this.$router.push({ name: 'presupuestos' });
        }
        else if (this.$store.state.pedido.tipoOperacion == 'devolucion') {
          this.$router.push({ name: 'devoluciones' });
        }
      },


      setDescAsoc () {
        this.descAsocs = []
        //var descuentos = this.$store.state.pedido.descuentos
        var descuentos = [...this.$store.state.pedido.descuentos.map(obj => ({ ...obj }))];
        descuentos.forEach((j) => { 
            // afecta a productos 
            if (j.AfectaA == 1) {
                j.Productos.forEach((k) => { 
                    if (this.idProducto == k.Id) {
                        this.descAsocs.push(j) 
                    }
                })
            }
            // afecta a categoriasN1 
            if (j.AfectaA == 2) {
                j.CategoriaN1.forEach((k) => { 
                    if (this.categoriaN1 == k.Id) {
                        this.descAsocs.push(j) 
                    }
                })
            }
            // afecta a categoriasN2 
            if (j.AfectaA == 3) {
                j.CategoriaN2.forEach((k) => { 
                    if (this.categoriaN2 == k.Id) {
                        this.descAsocs.push(j) 
                    }
                })
            }
        })

        //var carrito = this.$store.state.pedido.carrito 
        var carrito = [...this.$store.state.pedido.carrito.map(obj => ({ ...obj }))];

        var descAsocsCarrito = []
        carrito.forEach((c)=> { 
            descuentos.forEach((d)=> { 
                // afecta a productos 
                if (d.AfectaA == 1) {
                    if (d.Productos.some(desc => desc.Id === c.id)) {
                        if (d.Excluyente) {
                            var de = {
                                Excluyente:  d.Excluyente,
                                Nivel: d.Nivel,
                                Secuencia: d.Secuencia,
                            }
                            descAsocsCarrito.push(de) 
                        }
                    }
                }
                // afecta a categoriasN1 
                if (d.AfectaA == 2) {
                    if (d.CategoriaN1.some(desc => desc.Id === c.idCategoria)) {
                        if (d.Excluyente) {
                            var de = {
                                Excluyente:  d.Excluyente,
                                Nivel: d.Nivel,
                                Secuencia: d.Secuencia,
                            }
                            descAsocsCarrito.push(de) 
                        }
                    }
                }
                // afecta a categoriasN2 
                if (d.AfectaA == 3) {
                    if (d.CategoriaN2.some(desc => desc.Id === c.idSubcategoria)) {
                        if (d.Excluyente) {
                            var de = {
                                Excluyente:  d.Excluyente,
                                Nivel: d.Nivel,
                                Secuencia: d.Secuencia,
                            }
                            descAsocsCarrito.push(de) 
                        }
                    }
                }
            })
        })
        var auxxx = [] 
        this.descAsocs.forEach((d)=> { 
            var inc = true
            descAsocsCarrito.forEach((dc)=> { 
                if (d.nivel = dc.Nivel) {
                    inc = false
                }
            })
            if (inc) {
                auxxx.push(d)    
            }
        })
        this.descAsocs = auxxx
      }

    },

    mounted() {
      this.$store.commit('loader/stop')
      this.onResize()
      this.$store.commit('pedido/saveTipoOperacion','pedido');
      localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
      this.seleccion = 0;
      this.$store.commit('pedido/setSeleccion',this.seleccion);
      this.showItems();
    },

    created() {
     window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
     window.removeEventListener('resize', this.onResize)
    }

 }



</script>

<style scoped>


#info-container{
display: flex;
flex-direction: column;
}

#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60);
}

#popup-realizar-pedido{
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 400px;
border-radius: 15px;
box-sizing: border-box;
background: #ffffff;
border-style: solid;
border-width: 1px;
border: 1px solid #dddddd;
}


#popup-btnClose-container{
  display: flex;
  flex-direction:row;
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;
  justify-content: flex-end;
  background:  #ffffff
}


#popup-titulo{
 margin-bottom: 15px;
 font-size: 26px;
 color: #5C666F;
 text-align: center;
}


#popup-container{
  display: flex;
  flex-direction:row;
  width: 380px;
  height: 210px;
  background:  #ffffff
}


.popupMaximoPorcentaje{
  font-size: 8px; 
  color: #5C666F;
}

.popupMaximoPorcentajeInv{
  font-size: 8px; 
  color: #ff0000;
}


.popup-container-inline{
  display: flex;
  flex-direction:row;
  background:  #ffffff
}


#popup-image-container{
  width: 160px;
  height: 150px;
  margin-top:35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#popup-image{
  max-width: 90%;
  max-height: 90%;
}

#popup-producto{
 margin-top: 5px;
 font-size: 15px;
 color: #5C666F;
 font-weight: bold;
}

#popup-descripcion-producto{
 margin-top: 6px;
 font-size: 11px;
 color: #5C666F;
}

#popup-precio-unitario{
 margin-top: 0px;
 margin-bottom: 20px;
 font-size: 24px;
 font-weight: 500;
 color: #5C666F;
}

#popup-cantidad-label{
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}

#popup-subtotal-label{
 margin-top: 10px;
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}


.popupCantidad{
 font-size: 12px;
 color: #5C666F;
 width: 40px;
 height:20px;
 /* margin-left: 80px; */
 border-style: solid;
 border-radius: 5px;
 border:none;
 border-width: 1px;
 border: 1px solid #dddddd;
 text-align: center;
 outline: none;
}


.popupCantidadInv{
 font-size: 12px;
 color: #5C666F;
 width: 40px;
 height:20px;
 /* margin-left: 80px; */
 border-style: solid;
 border-radius: 5px;
 border:none;
 border-width: 1px;
 border: 1px solid #ff0000;
 text-align: center;
 outline: none;
}

#popupDetalle {
  width: 245px;
  padding-left: 5px;
  margin-left: 10px;
  border-radius: 5px;
  height: 40px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;
}


#popup-subtotal{
 font-size: 14px;
 margin-left: 80px;
 color: #5C666F;
}


#btnContainerPopup{
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}


#btnCerrarPopup{
  width: 100px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}

#btnAgregarPopup{
  width: 160px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  color: #ffffff;
  outline: none;
}

#btnCerrarPopup:hover { cursor: pointer; }
#btnAgregarPopup:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }



 #subheader {
 width: 100%;
 height: 35vh;
 background: linear-gradient(#005A9F , #1899D6);
 }


#main-container{
 position: absolute;
 top: 55vh;
 left: 50%;
 transform: translate(-50%,-50%);
 width: 700px;
 height: 85vh;
 }


#label-container{
  width: 700px;
  height: 10vh;
 }

#label{
  color:#ffffff;
  font-size: 27px;
 }


#container{
  width: 700px;
  height: 65vh;
  border-width: 1px;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  background-color: #ffffff;
 }

#list-header-container{
  height: 13vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
 }

#busqueda{
 border-radius: 20px;
 width: 400px;
 margin-top:15px;
 padding-left: 40px;
 height:30px;
 border-style: solid;
 border:none;
 border-width: 1px;
 border: 1px solid #dddddd;
 color: #000000;
 outline: none;
 background: white url(/dist/icon-search.png) left no-repeat ;
 background-size: 25px 25px;
 background-position: 10px;
}


.seleccion{
 color:#2292CD;
 font-weight: normal;
 margin-left:0 auto;
 margin-right: 0 auto;
 margin-top: 0px;
 font-size: 11px;
 font-weight: 500;
 text-align: center;
 }


.seleccion:hover{
    cursor: pointer;
  }


#separador{
 margin-left: 15px;
 margin-right: 15px;
 font-weight: 500;
 font-size: 13px;
 color:#dddddd;
 }


#list-container{
 width: 630px;
 height: 49vh;
 margin-left: 25px;
 margin-right: 25px;
 overflow: auto;
 background-color: #ffffff;
 }



#btnContainer{
  width: 660px;
  height: 10vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
 }


#btnAgregarPromo{
  width: 120px;
  height: 30px;
  font-size: 9px;
  margin-left: 5px;
  margin-right: 5px;
  border-style: solid;
  border:none;
  color: #4969B2;
  background: #ffffff;
  border-radius: 20px;
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}


#btnCarrito{
  width: 100px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  border:none;
  background: #44C7F4;
  border-radius: 20px;
  color: #ffffff;
  outline: none;
}



#btnAgregarPromo:hover{cursor: pointer;}
#btnCarrito:hover{cursor: pointer;}
#sortSelected:hover{cursor: pointer;}
#sortOptions:hover{cursor: pointer;}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .5s;
}

.fade-enter-active {
  transition-delay: .01s;
}

.fade-enter, .fade-leave-active {
  opacity: 0}


.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}

/*-----------------------------------------------------------------------------------------------------------------------*/

/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #dddddd;
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #cccccc;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #bbbbbb;
}



::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #dddddd;
    opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #dddddd;
}

::-ms-input-placeholder { /* Microsoft Edge */
    color: #dddddd;
}



@media only screen and (max-width: 600px) {

  ::-webkit-scrollbar {
      width: 0px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 1px #ffffff;
      border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #ffffff;
      border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #bbbbbb;
  }

}


</style>



// WEBPACK FOOTER //
// src/components/views/realizarPedido/realizarPedido.vue